import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose, setDisplayName } from 'recompose';
import qs from 'query-string';
import {
  SmartDialog,
  SmartForm,
} from 'components';
import immutableToJS from 'helpers/immutableToJS';
import { verifyEmail } from 'redux/auth/actions';
import { selectState } from 'redux/selectors';

class VerificationDialog extends Component {
  static propTypes = {
    location: PropTypes.func.isRequired,
    email: PropTypes.string.isRequired,
    push: PropTypes.func.isRequired,
    verificationCode: PropTypes.string.isRequired,
    emailVerificationError: PropTypes.shape({}).isRequired,

    formatMessage: PropTypes.func.isRequired,
    verifyEmail: PropTypes.func.isRequired,
  };

  state = { message: this.props.formatMessage('Verification is in progress...') };

  componentWillMount() {
    const { email, verifyEmail, verificationCode } = this.props;
    this.timer = setTimeout(() => {
      verifyEmail({
        email,
        verificationCode,
        onSuccess: this.onSuccess,
      });
    }, 1000);
  }

  componentWillUnmount() {
    clearTimeout(this.timer);
  }

  onSuccess = () => {
    const { formatMessage } = this.props;
    this.setState({ message: formatMessage('Log in to start.') });
  }

  onClose = () => {
    const { push, location } = this.props;
    const { profileUrl, vendorEmail, asConsumer } = qs.parse(location.hash.slice(1));
    if (profileUrl) {
      const vendorEmailPathname = vendorEmail ? `&vendorEmail=${encodeURIComponent(vendorEmail)}` : '';
      const pathname = profileUrl ? `/?profileUrl=${encodeURIComponent(profileUrl)}${vendorEmailPathname}#signin` : '';
      push(pathname);
    } else if (asConsumer) {
      const pathname = asConsumer ? `/?asConsumer=${encodeURIComponent(asConsumer)}#signin` : '';
      push(pathname);
    } else {
      push('/#login');
    }
  }

  render() {
    const { email, formatMessage, emailVerificationError } = this.props;
    const message = emailVerificationError.detail || this.state.message;
    const hasError = emailVerificationError.detail;
    return (
      <SmartDialog
        noPadding
        onClose={this.onClose}
        open
        title={`${formatMessage('Your email ')} ${email} is verified.`}
      >
        <SmartForm
          fields={[]}
          onSave={this.onClose}
          saveButton={formatMessage('Ok')}
        >
          <div style={{ marginLeft: 16, fontSize: 15 }}>
            <div style={{ color: hasError ? 'red' : 'black' }}>
              {message}
            </div>
          </div>
        </SmartForm>
      </SmartDialog>
    );
  }
}

/* istanbul ignore next */
const mapStateToProps = state => ({
  ...selectState('auth', 'emailVerification')(state, 'emailVerification'),
});

/* istanbul ignore next */
const mapDispatchToProps = dispatch => ({
  verifyEmail: payload => dispatch(verifyEmail(payload)),
});

export default compose(
  setDisplayName('VerificationDialog'),
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  immutableToJS,
)(VerificationDialog);
